(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-info-image-container"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animated-box"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    

function initAcc(elem, option) {
    console.log('loading')
    // addEventListener on mouse click
    document.addEventListener('click', function (e) {
        // check is the right element clicked
        if (! e.target.matches(elem + ' .a-btn')) 
            return;
         else {
            // check if element contains active class
            if (! e.target.parentElement.classList.contains('active')) {
                if (option == true) {
                    // if option true remove active class from all other accordions
                    var elementList = document.querySelectorAll(elem + ' .a-container');
                    Array.prototype.forEach.call(elementList, function (e) {
                        e.classList.remove('active');
                    });
                }
                // add active class on cliked accordion
                e.target.parentElement.classList.add('active');
            } else {
                // remove active class on cliked accordion
                e.target.parentElement.classList.remove('active');
            }
        }
    });
}

// activate accordion function
initAcc('.accordion', true)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let scrollpos = window.scrollY;
  const header = document.querySelector(".site-header");
  const header_height = header.offsetHeight;

  const add_class_on_scroll = () => {
    header.classList.remove("md:bg-transparent");
    header.classList.add("md:bg-tertiary-light");
    header.classList.add("bg-full");
  }
  const remove_class_on_scroll = () => {
    header.classList.add("md:bg-transparent");
    header.classList.remove("md:bg-tertiary-light");
    header.classList.remove("bg-full");
  }

  window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;
    if (scrollpos >= header_height) { add_class_on_scroll() }
    else { remove_class_on_scroll() }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-image-container"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-image-list-container"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-2"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-rose"] && !Shopify.designMode) return;
  try {
    

var pillsControl = {
    makeActive: (event) => {
        document.querySelector('.nav-pills .active').classList.remove('active')
        event.currentTarget.classList.add('active')
        let showContent = event.currentTarget.dataset.for
        document.querySelector('.display-sections .active').classList.remove('active')
        document.querySelector('#' + showContent).classList.add('active')
    }
}

$(window).on('load', function () {
    console.log($('.slider-for'))

    $('.lazy-img').each((i, img) => {
        let src = img.dataset.src
        img.src = src
        img.classList.remove('hidden')
    })


    $('.nav-pills .btn').click(pillsControl.makeActive)
    $('.slider-for').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'

    });
    $('.slider-nav').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true
    });

   


})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-tailwind-ceremony"] && !Shopify.designMode) return;
  try {
    

var pillsControl = {
  makeActive: (event)=>{
    document.querySelector('.nav-pills .active').classList.remove('active')
    event.currentTarget.classList.add('active')
    let showContent = event.currentTarget.dataset.for 
    document.querySelector('.display-sections .active').classList.remove('active')
    document.querySelector('#'+showContent).classList.add('active')
  }
} 





    $(window).on('load', function(){
      console.log($('.slider-for'))

      $('.lazy-img').each((i, img)=>{
        let src = img.dataset.src 
        img.src = src
        img.classList.remove('hidden')
      })

      $('.nav-pills .btn').click(pillsControl.makeActive)
    $('.slider-for').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav',

      });
      $('.slider-nav').not('.slick-initialized').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true
      });

      $('.first-image').css('width', document.getElementById('mainSlider').offsetWidth)


    })



      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-tailwind-variety"] && !Shopify.designMode) return;
  try {
    
  updateVariantOption = (optionIndex, optionValue) => {
    console.log(optionIndex, optionValue);
    // Update active state for buttons
    const buttons = document.querySelectorAll(`.single-option-selector[data-option-index="${optionIndex}"]`);
    buttons.forEach((button) => button.classList.remove('active'));

    const selectedButton = document.querySelector(
      `.single-option-selector[data-option-index="${optionIndex}"][data-option-value="${optionValue}"]`
    );
    selectedButton.classList.add('active');
    selectedButton.blur();

    let price = selectedButton.dataset.optionPrice;
    let compareAtPrice = selectedButton.dataset.optionCompareAtPrice;
    console.log('Price', price);
    console.log('Compare At Price', compareAtPrice);

    let AddToCartButton = document.querySelector('.product-form__cart-submit');
    let addCartText = "Add To Cart"
    let newText = `<span>${addCartText} - <s>${compareAtPrice}</s> ${price}</span>`;
    console.log('Add to Cart Button', AddToCartButton);
    AddToCartButton.innerHTML = newText;

    // Update the hidden <select> for the option
    const selectElement = document.getElementById(`SingleOptionSelector-${optionIndex - 1}`); // optionIndex is 1-based, select is 0-based
    if (selectElement) {
      selectElement.value = optionValue;
      const event = new Event('change');
      selectElement.dispatchEvent(event); // Trigger change event for Shopify to detect variant change
      console.log(selectElement);
    }
  };

  var pillsControl = {
    makeActive: (event) => {
      document.querySelector('.nav-pills .active').classList.remove('active');
      event.currentTarget.classList.add('active');
      let showContent = event.currentTarget.dataset.for;
      document.querySelector('.display-sections .active').classList.remove('active');
      document.querySelector('#' + showContent).classList.add('active');
    },
  };

  $(window).on('load', function () {
    console.log('Slidder', $('.slider-for'));

    $('.lazy-img').each((i, img) => {
      let src = img.dataset.src;
      img.src = src;
      img.classList.remove('hidden');
    });

    $('.nav-pills .btn').click(pillsControl.makeActive);
    $('.slider-for').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
    });
    $('.slider-nav').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      arrows: true,
      centerMode: true,
      focusOnSelect: true,
    });
  });

  // Attach a click event listener to every dropdown header.
  document.querySelectorAll('.dropdown-toggle').forEach((button) => {
    button.addEventListener('click', function () {
      const content = this.nextElementSibling;
      content.classList.toggle('hidden');
      // Rotate the arrow icon for visual feedback.
      this.querySelector('svg').classList.toggle('rotate-180');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-tailwind"] && !Shopify.designMode) return;
  try {
    
  updateVariantOption = (optionIndex, optionValue) => {
    console.log(optionIndex, optionValue);
    // Update active state for buttons
    const buttons = document.querySelectorAll(`.single-option-selector[data-option-index="${optionIndex}"]`);
    buttons.forEach((button) => button.classList.remove('active'));

    const selectedButton = document.querySelector(
      `.single-option-selector[data-option-index="${optionIndex}"][data-option-value="${optionValue}"]`
    );
    selectedButton.classList.add('active');
    selectedButton.blur();

    // Update the hidden <select> for the option
    const selectElement = document.getElementById(`SingleOptionSelector-${optionIndex - 1}`); // optionIndex is 1-based, select is 0-based
    if (selectElement) {
      selectElement.value = optionValue;
      const event = new Event('change');
      selectElement.dispatchEvent(event); // Trigger change event for Shopify to detect variant change
      console.log(selectElement);
    }
  };

  var pillsControl = {
    makeActive: (event) => {
      document.querySelector('.nav-pills .active').classList.remove('active');
      event.currentTarget.classList.add('active');
      let showContent = event.currentTarget.dataset.for;
      document.querySelector('.display-sections .active').classList.remove('active');
      document.querySelector('#' + showContent).classList.add('active');
    },
  };

  $(window).on('load', function () {
    console.log('Slidder', $('.slider-for'));

    $('.lazy-img').each((i, img) => {
      let src = img.dataset.src;
      img.src = src;
      img.classList.remove('hidden');
    });

    $('.nav-pills .btn').click(pillsControl.makeActive);
    $('.slider-for').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
    });
    $('.slider-nav').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      centerMode: true,
      focusOnSelect: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-body"] && !Shopify.designMode) return;
  try {
    
  
function printRecipe(){
  var prtContent = document.getElementById("print-recipe-details");
  var WinPrint = window.open("", "", "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0");
  WinPrint.document.write(prtContent.innerHTML);
  WinPrint.document.close();
  WinPrint.focus();
  WinPrint.print();
  WinPrint.close();
}
$('#printRecipe').click(()=>{
  console.log('print clicked')
  printRecipe()}) 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-vertical"] && !Shopify.designMode) return;
  try {
    

// custom js to run on load here


  } catch(e) { console.error(e); }
})();
})();
